export default "__VITE_ASSET__159b566e__"